import styled from "@emotion/styled"
import { PIcon } from "@porsche-design-system/components-react"
import type { PIconProps } from "@porsche-design-system/components-react"
import { colorErrorFrosted, colorWarningFrosted } from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export interface TagIconProps {
	className?: string
	color?: "error" | "warning"
	compact?: boolean
	iconName?: PIconProps["name"]
	iconSource?: string
}

export const TagIcon = ({ color, compact, iconName, iconSource, ...rest }: TagIconProps) => {
	return color ? (
		<Background {...rest} $background={color} $compact={compact}>
			<PIcon name={iconName} size={compact ? "2xs" : "xs"} source={iconSource} />
		</Background>
	) : (
		<StandardIcon
			{...rest}
			name={iconName}
			size={compact ? "2xs" : "xs"}
			source={iconSource}
			color="contrast-high"
		/>
	)
}

const colorMap: Record<NonNullable<TagIconProps["color"]>, string> = {
	error: colorErrorFrosted,
	warning: colorWarningFrosted,
}

const Background = styled("span", { shouldForwardProp })<{ $background: TagIconProps["color"]; $compact?: boolean }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: ${({ $compact }) => ($compact ? "18px" : "24px")};
	height: ${({ $compact }) => ($compact ? "18px" : "24px")};
	padding: 3px;
	flex-shrink: 0;
	background: ${({ $background }) => ($background ? colorMap[$background] : undefined)};
	border-radius: 50%;
`

const StandardIcon = styled(PIcon)<{ $compact?: boolean }>`
	padding: 4px;
`
